import template from './sso.html'
import './sso.scss'

const sso = {
  bindings: { link: '<' },
  template,
  controller: /* @ngInject */ class SsoController {
    constructor (URLS) {
      this.URLS = URLS
    }

    redirect (url) {
      window.location.assign(url)
    }

    signUpWithMicrosoft () {
      this.redirect(this.URLS.wonkers.microsoftSignup)
    }

    loginWithMicrosoft () {
      this.redirect(this.URLS.wonkers.microsoftSignin)
    }
  }
}

export default sso
